import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: i * 0.09, ease: EASE } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", as = "h2", onLoad = false, baseDelay = 0 }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <Tag initial="hidden" {...trigger} className={className}>
      {lines.map((line, i) => (
        <span key={i} className={`block overflow-hidden pb-[0.08em] ${lineClassName}`}>
          <motion.span className="block" custom={i + baseDelay} variants={lineVariants}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const SectionLabel = ({ index, children, dark = false }) => (
  <div className={`flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] ${dark ? "text-[#A39E93]" : "text-[#6E685E]"}`}>
    <span className="sl-index text-[#C26D38]"><span className="sl-orig">({index})</span></span>
    <span className={`h-px w-10 ${dark ? "bg-[#F7F5F0]/25" : "bg-[#121110]/25"}`} />
    <span>{children}</span>
  </div>
);
